import { useFormContext } from "react-hook-form";

import { Translate } from "shared/components/Translate";

import { ICheckboxProps } from "./interface";
import styles from "./styles";

const Checkbox: React.FC<ICheckboxProps> = ({
  id,
  label,
  onChange,
  defaultChecked = false,
  ...rest
}: ICheckboxProps) => {
  const { register } = useFormContext();

  return (
    <styles.InputWrapper>
      <styles.Box>
        <input
          {...rest}
          type="checkbox"
          {...register(id, {
            onChange,
          })}
          defaultChecked={defaultChecked}
        />
        <svg viewBox="0 0 21 21">
          <polyline points="5 10.75 8.5 14.25 16 6" />
        </svg>
      </styles.Box>
      <styles.Label>
        <Translate value={label} />
      </styles.Label>
    </styles.InputWrapper>
  );
};

export default Checkbox;
